module.exports = __webpack_public_path__ + "static/media/045.3ca8c5c6.png";